// Constructor de rutinas — el motor vive en el backend (/store/rutina).
import { storeFetch } from './storeFetch';

// Handles de productos sueltos que el motor sabe acomodar (sin kits).
export async function getProductosRutina() {
  const data = await storeFetch('/store/rutina/productos');
  return data.handles || [];
}

export async function getCuestionario() {
  const data = await storeFetch('/store/rutina/cuestionario');
  return data.preguntas || [];
}

// body: { respuestas } para el diagnóstico, o { productos: [handle], perfil } por producto.
export async function crearRutina(body) {
  return storeFetch('/store/rutina', { method: 'POST', body: JSON.stringify(body) });
}

// Manda la rutina del diagnóstico en PDF + cupón del 10% al correo.
export async function enviarRutina({ email, nombre, respuestas }) {
  return storeFetch('/store/rutina/enviar', {
    method: 'POST',
    body: JSON.stringify({ email, nombre, respuestas }),
  });
}
